/* @jsxImportSource react */

import { cn } from '@packages/shared/src/utils/cn/cn';
import type { CSSProperties, ReactNode } from 'react';

interface CssWithCustomProperties extends CSSProperties {
  '--min-card-width': string;
}

export type ProductCardGridProps = {
  children: ReactNode;
  defaultMinCardWidth: string;
  className?: string;
};

// NOTE: the more obvious approach of using a `gap` in the `ul` and `gap-0` in the `li` does not work, because currently empty grid tracks are not collapsed, and so the gap leads to unexpected whitespace in the individual `li` elements using subgrid
export const ProductCardGrid = ({
  children,
  className,
  defaultMinCardWidth,
}: ProductCardGridProps) => {
  const style: CssWithCustomProperties = {
    '--min-card-width': defaultMinCardWidth,
  };

  return (
    <div className="product-card-grid-wrapper flex flex-col">
      <ul
        // NOTE: the specific class with the min size is necessary to be able to react to specific sizes in custom css, because variables are not supported in media queries
        className={cn(
          `product-card-grid min-card-width-${defaultMinCardWidth} grid gap-x-2`,
          className,
        )}
        style={style}
      >
        {children}
      </ul>
    </div>
  );
};
